import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'createPost');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'posts',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/createPost.js